import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";

const stats = [
  { value: "500K+", label: "SEA Users Reached", sub: "东南亚平台用户覆盖", color: "#FF1C35" },
  { value: "8+", label: "Hit Titles Released", sub: "爆款短剧作品", color: "#FF1C35" },
  { value: "7–14", label: "Days Per Production", sub: "标准化制作周期（天）", color: "#FF1C35" },
  { value: "RM 16M+", label: "Total Revenue Generated", sub: "累计内容营收", color: "#FF1C35" },
];

const Stats = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setVisible(true); }, { threshold: 0.3 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section ref={ref} style={{ padding: "80px 40px", borderTop: "1px solid rgba(255,255,255,0.05)" }}>
      <div style={{ maxWidth: 1100, margin: "0 auto", display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: 24 }}>
        {stats.map((s, i) => (
          <motion.div
            key={s.label}
            initial={{ opacity: 0, y: 30 }}
            animate={visible ? { opacity: 1, y: 0 } : {}}
            transition={{ delay: i * 0.12, duration: 0.6 }}
            style={{
              textAlign: "center", padding: "36px 24px",
              background: "rgba(255,255,255,0.03)",
              border: "1px solid rgba(255,255,255,0.07)",
              borderRadius: 16,
              boxShadow: "0 8px 30px -6px rgba(255,28,53,0.08)",
            }}
          >
            <div style={{ fontSize: 52, fontWeight: 900, color: s.color, lineHeight: 1, letterSpacing: -1 }}>{s.value}</div>
            <div style={{ marginTop: 12, fontSize: 15, fontWeight: 600, color: "rgba(255,255,255,0.85)" }}>{s.label}</div>
            <div style={{ marginTop: 4, fontSize: 12, color: "rgba(255,255,255,0.35)" }}>{s.sub}</div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Stats;
